import MarketingBannerV2 from './MarketingBannerV2';

export default MarketingBannerV2;
